import { defineAsyncComponent } from 'vue'

export default app => {
  app.component('PlatformAccountPage', defineAsyncComponent(() => import('./AccountPage')))
  app.component('PlatformAccountPageContainer', defineAsyncComponent(() => import('./AccountPageContainer')))
  app.component('PlatformAccountPasswordForm', defineAsyncComponent(() => import('./AccountPasswordForm')))
  app.component('PlatformAccountSettingsForm', defineAsyncComponent(() => import('./AccountSettingsForm')))
  app.component('PlatformAddApplicationListPage', defineAsyncComponent(() => import('./AddApplicationListPage')))
  app.component('PlatformAddApplicationToAccountForm', defineAsyncComponent(() => import('./AddApplicationToAccountForm')))
  app.component('PlatformEditApplicationForm', defineAsyncComponent(() => import('./EditApplicationForm')))
  app.component('PlatformEmailVerificationForm', defineAsyncComponent(() => import('./EmailVerificationForm')))
  app.component('PlatformMyApplicationsPage', defineAsyncComponent(() => import('./MyApplicationsPage')))
  app.component('PlatformNotificationPreferenceForm', defineAsyncComponent(() => import('./NotificationPreferenceForm')))
  app.component('PlatformToggleUsageDataForm', defineAsyncComponent(() => import('./ToggleUsageDataForm')))
  app.component('PlatformTwoFactorAuthSettings', defineAsyncComponent(() => import('./TwoFactorAuthSettings')))
  app.component('PlatformUserProfile', defineAsyncComponent(() => import('./UserProfile')))
}
